import { jsx, jsxs } from 'react/jsx-runtime';
import * as Headlessui from '@headlessui/react';
import classNames from 'classnames';
import { Icon } from '../../Icon/Icon.es.js';

const MenuItem = ({ className, label, icon, inactive = false, variant = 'primary', disabled, ...rest })=>{
    if (!inactive) {
        return jsx(Headlessui.Menu.Item, {
            as: "a",
            className: classNames('cb-menu-item', {
                disabled
            }, className),
            disabled: disabled,
            ...rest,
            children: ({ active })=>jsxs("div", {
                    className: classNames('item-container', {
                        [variant]: active,
                        default: !active
                    }),
                    children: [
                        icon && jsx(Icon, {
                            className: "icon",
                            name: icon,
                            size: 16
                        }),
                        jsx("p", {
                            children: label
                        })
                    ]
                })
        });
    }
    return null;
};
MenuItem.displayName = 'Menu.Item';

export { MenuItem, MenuItem as default };
//# sourceMappingURL=Menu.Item.es.js.map
